import axios from "axios"
import Config from "../../config"
import router from "../../router"
import authenticatedAxios from "../../authenticated-axios"


// authenticatedAxios.defaults.withCredentials = false

const profile = {
    namespaced: true,
    state: {
        user: {},
        emailErrorMsg: null,
        usernameErrorMsg: null,
        subscriptionDetails: {},
        verficationCode: "",
        isDeveloper: null,
    },
    mutations: {
        updateUserProfile(state, response) {
            if (response) {
                state.user = response
            }
        }
    },
    actions: {
        getUserProfile({commit}) {
            // console.log("<====getUserProfile===>")
            return new Promise((resolve, reject) => {
                authenticatedAxios({
                    method: "get",
                    url: `${Config.api.url}/users/user`,
                }).then((response) => {
                    commit("updateUserProfile", response.data)
                    resolve(response)
                }).catch(error => {
                    console.log("Error", error)
                    if (error.response.data === "Invalid session, no ticket provided, no username/password provided" || error.response.status === 401 || error.response.status === 403) {
                        router.push({name: "login"})
                    }
                    reject(error)
                })
            })
        },
        getUserProfileByStatus({commit}, payload) {
            return new Promise((resolve, reject) => {
                axios.get(`${Config.api.url}/users/user-by-status`, {
                    params: payload
                }).then((response) => {
                    // console.log(response.data)
                    resolve(response.data)
                }).catch(error => {
                    reject(error.response)
                })
            })
        },
        validateEmail({commit, state}, id) {
            state.emailErrorMsg = null
            // console.log("<====validateEmail===>")
            // console.log(`${Config.api.url}/users/validate-email/${id}`)
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: `${Config.api.url}/users/validate-email/${id}`,
                    data: id
                }).then((response) => {
                    // console.log(response.data)
                    if (response.data) {
                        resolve(response.data)
                    }
                }).catch(error => {
                    if (error.response.status === 422 || error.response.status === 400) {
                        resolve({
                            "errorMessage": id+ " is not a valid email address."
                        })
                    } else {
                        reject(error.response)
                    }
                })
            })
        },
        validateUsername({commit, state}, payload) {
            state.usernameErrorMsg = null
            // console.log("<====validateUsername===>")
            return axios.get(`${Config.api.url}/users/validate-username`, {
                params: payload
            }).then((response) => {
                if (response.data && response.data != null) {
                    if (response.data) {
                        state.usernameErrorMsg = null // means username is available so set error msg to null
                    }
                }
                return response.data
            }).catch(error => {
                console.log("Error", error)
                if (error.response.status === 400) {
                    state.usernameErrorMsg = error.response.data.response_message
                }
                throw error
            })
        },
        getSubscriptionDetailsFull({commit, state}) {
            state.usernameErrorMsg = null
            authenticatedAxios.get(`${Config.api.url}/users/trimmed-newsletter-full`).then((response) => {
                if (response.data) {
                    state.subscriptionDetails = response.data
                }
            }).catch(error => {
                console.log("Error", error)
            })
        },
        getSubscriptionDetailsMail({commit, state}, payload) {
            state.usernameErrorMsg = null
            axios.get(`${Config.api.url}/users/trimmed-newsletter-mail`, {
                params: payload,
            }).then((response) => {
                if (response.data) {
                    state.subscriptionDetails = response.data
                }
            }).catch(error => {
                console.log("Error", error)
            })
        },
        validateUserPermissions({state}) {
            state.isDeveloper = null
            const url = `${Config.api.url}/people/permissions`
            authenticatedAxios.get(url).then((response) => {
                state.isDeveloper = response.data
            }).catch(error => {
                if (error.response.status === 403) {
                    state.isDeveloper = false
                } else {
                    console.log("Error", error)
                    router.push({name: "login"})
                }
            })
        },
        updateVerificationCode({state}, code) {
            state.verficationCode = code
        }
    }
}

export default profile
